import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import { Grid, Typography } from '@material-ui/core';
import PXMetrics from './PXMetrics';
import Theme from '../ui/Theme';

export default function PXOverview({ erData }) {
  return (
    <>
      <Grid item style={{ backgroundColor: Theme.palette.secondary.main }}>
        <Typography
          style={{
            fontSize: '16px',
            fontWeight: '700',
            color: '#10182B',
            margin: '10px',
          }}
        >
          Overview
        </Typography>
      </Grid>

      {!_isEmpty(erData?.list) ? (
        <Grid item style={{ backgroundColor: Theme.palette.secondary.main, paddingBottom: '10px' }}>
          <Grid container direction="row" style={{ marginLeft: '15px' }}>
            {erData?.metrics?.map((card) => (
              <Grid item xs={3} key={card.name}>
                <PXMetrics
                  title={card.name}
                  value={card.percentage}
                  type={card.type}
                  delta={card.delta}
                  color={card.color}
                  subtext={card.subText}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      ) : null}
    </>
  );
}
